import { render, staticRenderFns } from "./CustomInspectores.vue?vue&type=template&id=1989019e"
import script from "./CustomInspectores.vue?vue&type=script&lang=js"
export * from "./CustomInspectores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapAddress: require('/opt/atlassian/pipelines/agent/build/components/Map/Address.vue').default})
